export default "__VITE_ASSET__CAu$QaNl__"